import _map from 'lodash/map';
import React, { Component, PropTypes } from 'react';
import { Row } from 'react-bootstrap';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import ComponentTitle from '../shared/ComponentTitle';
import Image from 'components/Image';
import { TITLE_TYPE } from '../../constants/FRNBaseStyles';
import convert from 'xml-js';
import translate from '../../utils/translate';

let Masonry;

if (process.env.BROWSER) {
  Masonry = require('masonry-layout');
}

/**
 * Class representing the weather images and videos uploaded by users.
 *
 * Dependent on feed - viewer_media
 */
class ViewerWeatherMedia extends Component {
  static propTypes = {
    FRN_rawResponses: PropTypes.array,
    title: PropTypes.string,
    titleType: PropTypes.string
  };

  static contextTypes = {
    config: PropTypes.object.isRequired
  }

  static defaultProps = {
    title: "Viewer Weather Images",
    titleType: TITLE_TYPE.MODULE_TITLE
  }

  state = {
    numberOfItems: 16
  }

  _updateMasonry(){
    return new Masonry(document.querySelector('.masonry-box'), {
      itemSelector: '.ViewerMediaUnit',
      masonry: {
        gutterWidth: 20,
        columnWidth: 100
      }
    });
  }

  _increaseNumberOfItems() {
    this.setState({
      numberOfItems: this.state.numberOfItems + 8
    });
  }

  _extractInfo = () => {
    const {title, titleType} = this.props;
    if (Array.isArray(this.props.FRN_rawResponses) && this.props.FRN_rawResponses[0] && typeof this.props.FRN_rawResponses[0].data === 'object') {
      const {
        FRN_rawResponses: [ {
          data: {
            rss: {
              channel: {
                item: viewerImages = []
                } = {}
              } = {}
            } = {}
          } = {} ] = []
        } = this.props;
      return {title, titleType, viewerImages};
    } else if (Array.isArray(this.props.FRN_rawResponses) && this.props.FRN_rawResponses[0] && typeof this.props.FRN_rawResponses[0].data === 'string') {
      let data = convert.xml2js(this.props.FRN_rawResponses[0].data, {compact: true});
      let {
            rss: {
              channel: {
                item: viewerImages = []
                } = {}
              } = {}
            } = data;

      viewerImages.forEach(item => {
              item['media:content'] = this._cleanXmlObj(item['media:content']);
              item.link = item.link ? item.link._text || item.link : '';
      });

      return {title, titleType, viewerImages};
    }

    return {title, titleType, viewerImages: []};
  }

  _cleanXmlObj(mediaContent) {
    return {
      ...mediaContent,
      '@url': mediaContent._attributes.url,
    };
  }

  render() {
    const {
      config: {
        appOptions: {
          language = 'en'
        } = {}
      } = {}
    } = this.context;
    const {title, titleType, viewerImages} = this._extractInfo();
    const numberOfItems = this.state.numberOfItems;
    const shouldDisplayViewMoreButton = (viewerImages.length > numberOfItems);
    const imageCols = _map(viewerImages.slice(0, numberOfItems), (item, i) =>
      <ViewerMediaUnit
        mediaData={item}
        key={i}
        onLoad={this._updateMasonry}
      />);

    if (!viewerImages.length) {
      return null;
    }

    return (
      <div className="ViewerWeatherMedia">
        <ComponentTitle titleType={titleType} title={title} />
        <Row className="masonry-box">
          <ReactCSSTransitionGroup transitionName="viewer-weather-media" transitionEnterTimeout={300} transitionLeaveTimeout={300}>
            {imageCols}
          </ReactCSSTransitionGroup>
        </Row>
        {shouldDisplayViewMoreButton ?
            <div className="ViewerWeatherMedia-viewMore" onClick={this._increaseNumberOfItems.bind(this)}>
              {translate('View More', language)}
              <span className="ViewerWeatherMedia-viewMore-icon"></span>
            </div>
          : null
        }
      </div>
    );
  }

}

/**
 * Class representing an individual media item that has been uploaded by a user.
 */
class ViewerMediaUnit extends Component {
  static propTypes = {
    mediaData: PropTypes.object.isRequired,
    onLoad: PropTypes.func
  };

  render() {
    const { mediaData = {}, onLoad } = this.props;
    let { 'media:content': { '@url': imageUri = '' } = {} } = mediaData;

    if (mediaData['media:content']._attributes
      && mediaData['media:content']._attributes.medium === 'video'
      && mediaData['media:thumbnail']._attributes) {
      imageUri = mediaData['media:thumbnail']._attributes.url;
    }

    if (mediaData['media:content']['@medium']
      && mediaData['media:content']['@medium'] === 'video'
      && mediaData['media:thumbnail']['@url']) {
      imageUri = mediaData['media:thumbnail']['@url'];
    }

    /* Breakpoints: XS: 0-767, S: 768-991, M: 992-1199, L: 1200-1469, XL: 1470-  */
    const imageBreakpoints = [
      { "maxWidth": 480, "widthVW": 100 },
      { "maxWidth": 768, "widthVW": 50 },
      { "maxWidth": 992, "widthVW": 33 },
      { "maxWidth": 1200, "widthVW": 33 },
      {                   "widthVW": 25 },
    ];

    if (imageUri) {
      const imageElement = <Image imageBreakpoints={imageBreakpoints} src={imageUri} alt={mediaData.title} imageClassNames={"ViewerMediaUnit col-4"} imageOnLoad={onLoad} />;

      if (mediaData.link) {
        return <a href={mediaData.link} target="_top">{imageElement}</a>;
      }

      return imageElement;
    } else {
      return null;
    }
  }

}

export default ViewerWeatherMedia;



// WEBPACK FOOTER //
// ./app/components/weather/ViewerWeatherMedia.js